module.exports = __webpack_public_path__ + "img/cargandoB.f0a5b699.gif";